import React, {useEffect, useState} from 'react';
import { styled } from '@mui/material/styles';
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

import {
	dataReloadDependants, dataRemoveFilter
} from "../../redux/data/dataActions";

import {
	appSetAlert, appSetModalContent
} from "../../redux/app/appActions";
import { axiosDelay } from "../../config/config";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import Button from '@mui/material/Button';
import Input from "@mui/material/Input";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import CommentIcon from '@mui/icons-material/Comment';
import Tooltip from '@mui/material/Tooltip';
import LinearProgress from '@mui/material/LinearProgress';
import StarIcon from "@mui/icons-material/Star";
import SubjectIcon from "@mui/icons-material/Subject";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import SortIcon from "@mui/icons-material/Sort";
import FilterListIcon from '@mui/icons-material/FilterList';
import useDataSource from "../../hooks/useDataSource";

const PREFIX = 'ProjectHubSetupEditProject';

const classes = {
    root: `${PREFIX}-root`,
    linearProgress: `${PREFIX}-linearProgress`,
    card: `${PREFIX}-card`,
    form: `${PREFIX}-form`,
    margin: `${PREFIX}-margin`,
    formEmbeddedActions: `${PREFIX}-formEmbeddedActions`,
    modelTypesLabel: `${PREFIX}-modelTypesLabel`,
    listContainer: `${PREFIX}-listContainer`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
		width: '100%',
		height: '100%',
		// overflow: 'hidden'
	},

    [`& .${classes.linearProgress}`]: {
		height: '1px'
	},

    [`& .${classes.card}`]: {
		height: '100%',
		width: '100%'
	},

    [`& .${classes.form}`]: {
        height: '550px'
    },

    [`& .${classes.margin}`]: {
		margin: theme.spacing(1),
		width: 'calc(100% - 16px)'
	},

    [`& .${classes.formEmbeddedActions}`]: {
		// position: 'absolute',
		// bottom: '0px',
		width: 'calc(100% - 32px)'
	},

    [`& .${classes.modelTypesLabel}`]: {
        color: 'rgba(0, 0, 0, 0.54)',
        padding: '0',
        fontSize: '10pt',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: '400',
        lineHeight: '1',
        letterSpacing: '0.00938em'
    },

    [`& .${classes.listContainer}`]: {
        overflow: 'auto',
        height: '350px',
        marginTop: '8px'
    }
}));

export default function ProjectHubSetupEditProject({ configuration }) {

	const dispatch = useDispatch();

	// App State
	const config = useSelector(state => state.config);
	const filters = useSelector(state => state.data.filters);
	const isThemeLight = useSelector(state => state.persist.themeLight);
	const modalContent = useSelector(state => state.app.modalContent);

    // Component State
	const dataSourceName = configuration?.dataSource?.name ? configuration?.dataSource?.name : '';
    const [modelTypesLoaded, setModelTypesLoaded] = useState(false);
    const [modelTypes, setModelTypes] = useState([]);
    const [checked, setChecked] = useState([0]);
	const [projectsLoaded, setProjectsLoaded] = useState(false);
	const [project, setProject] = useState({});
	const dataSource = useDataSource(dataSourceName);
	const [clientValues, setClientValues] = useState([]);

	useEffect( () => {
		if (dataSource.data) {
			const clients = dataSource.data;
			const clientDD = clients.map(m => {
				return {value: m.clientid, label: m.clientname}
			})
			setClientValues(clientDD);
		}
	},[dataSource.data]);

	// const projectIsUnique = async (name) => {
	// 	const projectExists = dataSource.data.find(d => d.clientprojname.toLowerCase() === name.toLowerCase());
	// 	if (projectExists) {
	// 		return false;
	// 	} else {
	// 		return true;
	// 	}
	// };

	const schema = yup.object().shape({
		name: yup.string().required(), //.test("Project must be unique", "Project must be unique", projectIsUnique),
		client: yup.string().required(),
		description: yup.string().required(),
		number: yup.string().required(),
		tasknum: yup.string()
	});

	const resolver = yupResolver(schema);
	const { register, handleSubmit, formState, formState: { errors } } = useForm({ resolver });

    // Load up the Model Types for this Project
    useEffect(() => {

        setTimeout(function () {
			 (async () => {

				// Make first two requests
				const [availableModelTypes, assignedModelTypes, selectedProject] = await Promise.all([
					axios.get("{0}DBQuery?table=vwModelTypes&db={1}".format(config.data.authentication.api, config.data.authentication.apiSource)),
					axios.get("{0}DBQuery?table=vwProjectModelTypes&where=ProjectID eq {1}&db={2}".format(config.data.authentication.api, modalContent.filterValue, config.data.authentication.apiSource)),
					axios.get("{0}DBQuery?table=vwClientProjects&where=ProjectID eq {1}&db={2}".format(config.data.authentication.api, modalContent.filterValue, config.data.authentication.apiSource))
				]);

				if (availableModelTypes && assignedModelTypes && selectedProject && availableModelTypes.status === 200 && assignedModelTypes.status === 200 && selectedProject.status === 200) {
					const fs = [];
					const checked = [];
					const proj = [];
					for (const modelType of availableModelTypes.data) {

						// Enabled for role?
						const enabled = assignedModelTypes.data.find(af => af.modelTypeID === modelType.modelTypeID);
						if (enabled) {
							checked.push(enabled.modelTypeID);
						}
						fs.push({modelTypeID: modelType.modelTypeID, modelType: modelType.modelType, modelTypeVersion: modelType.modelTypeVersion, modelTypeDetails: modelType.modelTypeDetails, modelTypeEnabled: modelType.modelTypeEnabled});
					}
					for (const p of selectedProject.data) {
						proj.push({projectID: p.projectID, projectName: p.projectName, projectDesc: p.projectDesc, projectNum: p.projectNum, projectTaskNum: p.projectTaskNum, clientID: p.clientID, clientName: p.clientName, clientDesc: p.clientDescription})
					}

					setChecked(checked);
					setModelTypes(fs);
					setModelTypesLoaded(true);
					setProject(proj[0]);
					setProjectsLoaded(true);

				}
				else {
					console.log('**ERROR**', availableModelTypes.statusText, assignedModelTypes.statusText, selectedProject.statusText);

					dispatch(appSetAlert('Whoops!', 'Something went seriously wrong. Please try again.', 'error', 10000));

					setModelTypesLoaded(true);
					setProjectsLoaded(true);
				}
			})();

        }, JSON.parse(axiosDelay()));
    }, []);

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const handleClose = () => {
		dispatch(appSetModalContent(null));

		// -412 represents a filter applied for a click that produces a Modal (FormatUtilities.js --> FormatModalLink)
		const filterModalExists = filters.find(f => {
			return f.id.toLowerCase() === "-412"
		});
		if (filterModalExists) {
			// Remove the filter for modal because the user's intent is to get more data, not filter the app
			dispatch(dataRemoveFilter("-412"));
		}
    };

    const onSubmit = dataToPost => {
        // TODO: Any additional validation

        // Before we post get the user's ObjectID
        setTimeout(function () {

			const postBody = {
				"projectID": modalContent.filterValue,
				"projectName": dataToPost.name,
				"clientID": dataToPost.client,
				"projectDesc": dataToPost.description,
				"projectNum": dataToPost.number,
				"projectTaskNum": dataToPost.tasknum,
				"modelTypes": checked
			};

			const apiUrl = '{0}projectupdate?db={1}'.format(config.data.authentication.api, config.data.authentication.apiSource);

			// Here we pass a date time stamp to ensure the latest config is always loaded
			axios
				.post(apiUrl, postBody)
				.then(function (response) {

					dispatch(appSetAlert(null, '{0} was successfully updated.'.format(dataToPost.name), 'success', 10000));

					// Refresh Dependant Data Sources
					dispatch(dataReloadDependants( ["vwClientProjects", "vwModelTypes", "vwProjectModelTypes"] ));

					// Close the dialog and signal a reload
					// -412 represents a filter applied for a click that produces a Modal (FormatUtilities.js --> FormatModalLink)
					const filterModalExists = filters.find(f => {
						return f.id.toLowerCase() === "-412"
					});
					if (filterModalExists) {
						// Remove the filter for modal because the user's intent is to get more data, not filter the app
						dispatch(dataRemoveFilter("-412"));
					}
					handleClose();

				})
				.catch(function (error) {
					console.log('**ERROR**', error);

					dispatch(appSetAlert('Whoops!', 'Something went seriously wrong. Please try again.', 'error', 10000));

					// TODO: Reset state of form
				});

        }, JSON.parse(axiosDelay()));

    };

    return (
        <Root className={classes.root}>
			<div className={classes.card}>
				{!projectsLoaded &&
					<LinearProgress className={classes.linearProgress}/>
				}
                <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
					{projectsLoaded &&
						<React.Fragment>
							<FormControl variant="standard" className={classes.margin}>
								<InputLabel htmlFor="input-with-icon-adornment">Project Name</InputLabel>
								<Input
									{...register("name")}
									name="name"
									id="name"
									startAdornment={
										<InputAdornment position="start">
											<StarIcon />
										</InputAdornment>
									}
									inputProps={{
										"aria-label": "Name"
									}}
									defaultValue={project.projectName}
								/>
								{errors.name && <p style={{color: 'red'}}>Project Name is a required field.</p>}
							</FormControl>
							<FormControl variant="standard" className={classes.margin}>
								<InputLabel shrink htmlFor="input-with-icon-adornment">Client Name</InputLabel>
								<Select
                                    variant="standard"
                                    {...register("client")}
                                    name="client"
                                    id="client"
                                    input={
										<Input
											name="client"
											id="outlined-client-always-notched"
										/>
									}
                                    defaultValue={project.clientID}>
									{clientValues.map((r, index) =>
										<MenuItem key={index} value={r.value} primarytext={r.label}>{r.label}</MenuItem>
									)}
								</Select>
								{errors.client && <p style={{color: 'red'}}>Client is a required field.</p>}
							</FormControl>
							<FormControl variant="standard" className={classes.margin}>
								<InputLabel htmlFor="input-with-icon-adornment">Project Description</InputLabel>
								<Input
									{...register("description")}
									name="description"
									id="description"
									startAdornment={
										<InputAdornment position="start">
											<SubjectIcon />
										</InputAdornment>
									}
									inputProps={{
										"aria-label": "Description"
									}}
									defaultValue={project.projectDesc}
								/>
								{errors.description && <p style={{color: 'red'}}>Project Description is a required field.</p>}
							</FormControl>
							<FormControl variant="standard" className={classes.margin}>
								<InputLabel htmlFor="input-with-icon-adornment">Project Number</InputLabel>
								<Input
									{...register("number")}
									name="number"
									id="number"
									startAdornment={
										<InputAdornment position="start">
											<SortIcon />
										</InputAdornment>
									}
									inputProps={{
										"aria-label": "Project Number"
									}}
									defaultValue={project.projectNum}
								/>
								{errors.number && <p style={{color: 'red'}}>Project Number is a required field.</p>}
							</FormControl>
							<FormControl variant="standard" className={classes.margin}>
								<InputLabel htmlFor="input-with-icon-adornment">Project Task Number</InputLabel>
								<Input
									{...register("tasknum")}
									name="tasknum"
									id="tasknum"
									startAdornment={
										<InputAdornment position="start">
											<FilterListIcon />
										</InputAdornment>
									}
									inputProps={{
										"aria-label": "Task Number"
									}}
									defaultValue={project.projectTaskNum}
								/>
								{errors.tasknum && <p style={{color: 'red'}}>Task Number is a required field.</p>}
							</FormControl>
						</React.Fragment>
					}
                    {!modelTypesLoaded &&
                        <LinearProgress className={classes.linearProgress}/>
                    }
					{modelTypesLoaded &&
						<FormControl variant="standard" className={classes.margin}>
							<div className={classes.modelTypesLabel}>Model Types</div>
							<div className={classes.listContainer}>
								<List className={classes.list}>
									{modelTypes.map((modelType) => {
										const labelId = `checkbox-list-label-${modelType.modelTypeID}`;

										return (
                                            <ListItem key={modelType.modelTypeID} role={undefined} dense button
													  onClick={handleToggle(modelType.modelTypeID)}>
												<ListItemIcon>
													<Checkbox
														edge="start"
														checked={checked.indexOf(modelType.modelTypeID) !== -1}
														tabIndex={-1}
														disableRipple
														inputProps={{'aria-labelledby': labelId}}
													/>
												</ListItemIcon>
												<ListItemText id={labelId} primary={modelType.modelType}/>
												<ListItemSecondaryAction>
													<Tooltip title={modelType.modelTypeDetails}>
														<IconButton edge="end" aria-label="details" size="large">
															<CommentIcon/>
														</IconButton>
													</Tooltip>
												</ListItemSecondaryAction>
											</ListItem>
                                        );
									})}
								</List>
							</div>
						</FormControl>
					}
					<div className={classes.formEmbeddedActions}>
						<Button color={isThemeLight ? "primary" : "default"} onClick={() =>{ handleClose() }} disabled={formState.isSubmitting}>
							Cancel
						</Button>
						<Button color={isThemeLight ? "primary" : "default"} type="submit" disabled={formState.isSubmitting}>
							Submit
						</Button>
					</div>
                </form>
			</div>
		</Root>
    );
}
